import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'

const DefaultRouteRedirect: React.FC = () => {
  const { currentUser } = useAuth()
  const location = useLocation()

  const canAccessDashboard = currentUser?.role === 'admin'

  if (location.pathname === '/login') {
    return <Navigate to={canAccessDashboard ? '/admin/dashboard' : '/admin/dashboard'} replace />
  }

  return <Navigate to={location.pathname} replace />
}

export default DefaultRouteRedirect
